<template>
  <div>
    <LoadingContainer
      :is-loaded="isLoaded"
      :total="studentsLength"
      kind="Students"
    >
      <TransitionList class="students-list">
        <li v-for="s in students" :key="s.id" class="student-card">
          <span class="student-card__grade">
            {{ s.grade || '-' }}
          </span>
          <span class="student-card__name">
            {{ s.name }}
          </span>

          <button class="student-card__delete button" @click="deleteStudent(s.id)">
            <span class="u-screen-reader-only">Delete Student</span>
            <DeleteIcon />
          </button>

          <button class="student-card__edit button" @click="editStudent(s.id)">
            <span class="u-screen-reader-only">Edit Student</span>
            <EditIcon />
          </button>

          <ConfirmDelete
            :is-visible="isDeleting(s.id)"
            class="student-card__confirm"
            :title="s.name"
            @cancel="cancelDelete"
            @confirm="confirmDeleteStudent(s.id)"
          />

          <StudentForm
            class="student-card__form"
            v-if="isEditing(s.id)"
            @submit="saveEditedStudent"
            :student="{...s}"
            :title="`Edit Student: ${s.name}`"
            @cancel="cancelEditStudent"
          ></StudentForm>
        </li>
      </TransitionList>
    </LoadingContainer>

    <StudentForm
      v-if="showAdd"
      @submit="saveNewStudent"
      :student="newStudent"
      @cancel="clearStudent"
    />

    <SettingsAdd v-else @add="addStudent">
      Add Student
    </SettingsAdd>
  </div>
</template>

<script>
import store from '@/store'
import { mapActions, mapGetters } from 'vuex'

import DeleteIcon from 'bootstrap-icons/icons/trash.svg'
import EditIcon from 'bootstrap-icons/icons/pencil-square.svg'
import ConfirmDelete from '@/components/ConfirmDelete'
import StudentForm from '@/views/Settings/Forms/StudentForm'

export default {
  name: 'SettingsStudents',

  components: {
    DeleteIcon,
    EditIcon,
    ConfirmDelete,
    StudentForm
  },

  data () {
    return {
      editingStudent: undefined,
      deletingStudent: undefined,
      newStudent: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoaded: 'students/isLoaded',
      studentsLength: 'students/studentsLength',
      students: 'students/sortedStudents'
    }),

    showAdd () {
      return this.$route.query.add
    }
  },

  methods: {
    ...mapActions([
      'students/addStudent',
      'students/deleteStudent',
      'students/editStudent'
    ]),

    editStudent (id) {
      this.editingStudent = id
    },

    isEditing (id) {
      return id === this.editingStudent
    },

    saveEditedStudent (s) {
      this['students/editStudent'](s)
      this.editingStudent = undefined
    },

    cancelEditStudent () {
      this.editingStudent = undefined
    },

    deleteStudent (id) {
      this.deletingStudent = id
    },

    isDeleting (id) {
      return id === this.deletingStudent
    },

    cancelDelete () {
      this.deletingStudent = undefined
    },

    confirmDeleteStudent (id) {
      this['students/deleteStudent'](id)
      this.deletingStudent = undefined
    },

    addStudent () {
      this.$router.replace({
        name: 'settings-students',
        query: {
          add: true
        }
      })
    },

    clearStudent () {
      this.newStudent = {}

      this.$router.replace({
        name: 'settings-students'
      })
    },

    saveNewStudent () {
      this['students/addStudent'](this.newStudent)

      this.clearStudent()
    }
  },

  mounted () {
    store.dispatch('students/getStudents')
  }
}
</script>

<style lang="scss">
.student-card {
  margin-bottom: 2rem;
  display: grid;
  grid-template:
    "grade .    name delete edit" auto
    "form  form form form   form" auto /
     auto  1rem 1fr  auto   auto;
  align-items: center;
}

.student-card__grade {
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  grid-area: grade;
  border: .125rem solid #fff;
  border-radius: 1rem;
  background: #CFD8DC;
  text-transform: uppercase;
}

.student-card__name {
  grid-area: name;
  font-size: 1.4rem;
  font-weight: 700;
}

.student-card__delete {
  --button-fg: #B71C1C;
  --button-fg-active: #D32F2F;
  --button-width: 3rem;

  grid-area: delete;
}

.student-card__edit {
  --button-fg: #006064;
  --button-fg-active: #0097A7;
  --button-width: 3rem;

  grid-area: edit;
}

.student-card__form {
  margin-top: 1rem;
  padding: 1rem;
  grid-area: form;
  border-radius: 2.25rem;
  background-color: #fff;
}

.student-card__confirm {
  grid-area: form;
}
</style>
